export default "__VITE_ASSET__y3XSyctB__"